import { render, staticRenderFns } from "./PacienteCU.vue?vue&type=template&id=cb88a412"
import script from "./PacienteCU.vue?vue&type=script&lang=js"
export * from "./PacienteCU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports